// extracted by mini-css-extract-plugin
export default {"BreakpointFromMedium":"(min-width: 640px)","ScreenSMMin":"(min-width: 768px)","recipeGridDescription":"G26b245","recipeGridDescriptionText":"G3d036a"};